class AnimateOnScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Add the scroll event listener
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    // Get the current scroll position
    var scrollPosition = window.pageYOffset;
    var thiselementPosition = this.getBoundingClientRect().top;

    // Find the previous HTML element
    var prevElement = this.previousElementSibling;

    // Check if the element is in the viewport
    if (thiselementPosition <= ((window.innerHeight / 2) || document.documentElement.clientHeight) && thiselementPosition >= 0) {
      // Add the "animated" class to the element
      this.classList.add('animated');

      // Add the "animated-out" class to the previous element
      if (prevElement != null) {
        prevElement.classList.add('animated-out');
      };
    }
  }
}

customElements.define('period-timeline', AnimateOnScroll);
